export class MessagesSettings {
    static readonly SCREEN_MESSAGE      = 'message';
    static readonly SCREEN_PROPERTIES   = 'properties';
    static readonly SCREEN_SAVING       = 'saving';
    static readonly SCREEN_SAVE_FAILED  = 'saveFailed';
    static readonly SCREEN_SAVE_SUCCESS = 'saveSuccess';

    public minMessages: number      = 1;
    public maxMessages: number      = 3;
    public followUpAllowed: boolean = true;
    public editing: boolean         = false;
    public approvalMode: boolean    = false;
    public resetOnSave: boolean     = true;
    public startScreen: string      = MessagesSettings.SCREEN_MESSAGE;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/components/messages.settings.ts